module.exports = __webpack_public_path__ + "img/abc.58f6a9d3.svg";